export default {
  common: {
    loading: '加载中...',
    submit: '提交',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    search: '搜索',
    reset: '重置',
    back: '返回',
    success: '操作成功',
    error: '操作失败',
    noData: '暂无数据',
    required: '此项为必填',
    language: '语言',
  },
  nav: {
    home: '首页',
    jobs: '职位列表',
    profile: '职业画像',
    materials: '材料工坊',
    agent: 'AI 助手',
    settings: '账户设置',
    login: '登录',
    register: '注册',
    logout: '退出登录',
  },
  auth: {
    loginTitle: '登录 Sugar Link',
    registerTitle: '注册 Sugar Link',
    email: '邮箱',
    password: '密码',
    confirmPassword: '确认密码',
    forgotPassword: '忘记密码？',
    noAccount: '还没有账号？',
    hasAccount: '已有账号？',
    loginSuccess: '登录成功',
    registerSuccess: '注册成功',
  },
  jobs: {
    title: '职位列表',
    searchPlaceholder: '搜索职位、公司...',
    filter: '筛选',
    city: '城市',
    cohortType: '招聘类型',
    degreeReq: '学历要求',
    deadline: '截止日期',
    employer: '公司',
    apply: '申请职位',
    favorite: '收藏',
    unfavorite: '取消收藏',
    similar: '相似职位',
    description: '职位描述',
    requirements: '任职要求',
    skills: '技能要求',
  },
  profile: {
    title: '职业画像',
    basicInfo: '基本信息',
    fullName: '姓名',
    email: '邮箱',
    phone: '手机',
    educations: '教育经历',
    experiences: '工作经历',
    projects: '项目经历',
    skills: '技能标签',
    save: '保存画像',
    parseResume: '上传简历解析',
  },
  settings: {
    title: '账户设置',
    changePassword: '修改密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    dataExport: '导出我的数据',
    deleteAccount: '注销账号',
  },
}
